import { en } from './translations/en';
import { es } from './translations/es';
import { cn } from './translations/cn';
import { jp } from './translations/jp';
import { tw } from './translations/tw';
import { fr } from './translations/fr';

export const translations = {
  en, es, cn, jp, tw, fr
};
